<template>
  <ItemsQuestion
    v-if="parkOffersResidency"
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
  ></ItemsQuestion>
</template>

<script>
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'ResidencyProgramItemsQuestion',
    components: { ItemsQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    methods: {
      isValid () {
        if (!this.parkOffersResidency) {
          return true
        }
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    },
    computed: {
      parkOffersResidency () {
        return ParkPrograms.has(ParkPrograms.RESIDENCY, this.quizAnswers)
      }
    },
    watch: {
      parkOffersResidency: {
        immediate: true,
        handler () {
          if (!this.parkOffersResidency) {
            this.$emit('answerUpdated', {...this.answer, value: null})
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResidencyProgramItemsQuestion.vue?1e6aff07